import {ModuleComponent} from "../../js/module-component";
import {GvfService} from "../../../gvf/js/gvf-service";
import {GvfUiService} from "../../../gvf/js/gvf-ui-service";

export class ModRelatedProduct extends ModuleComponent {

    ready(){
        super.ready();

        this.viewMore = document.getElementById('viewmore');
        const productIds = this.$root.data('collections');

        this.findMember(`view-more-button`).click(
            (ev)=>{
                ev.preventDefault();
                const productsDiv = document.getElementById('products');
                GvfService.endpoint(
                    `/web/web-product/view-all-products-by-collection`,
                    {productIds:productIds},
                ).then(
                    (resp) => {
                        if(resp.html){
                            productsDiv.innerHTML = resp.html;
                            GvfUiService.init(this.$root);
                        }
                        this.viewMore.style.display = "none";
                    }
                );
            }
        );

    }

}